import { defineStore } from "pinia";
import { ref } from "vue";

export const useGlobalStore = defineStore(
  "globalStoreDetails",
  () => {
    const sitecoreData: any = ref(null);
    const allowedTerminals: any = ref({});
    const userEmail: any = ref(null);

    const updateSitecoreData = (data: any) => {
      sitecoreData.value = data;
    };

    const updateAllowedTerminals = (data: any) => {
      allowedTerminals.value = data;
    };

    const updateUserEmail = (data: any) => {
      userEmail.value = data;
    };
    return {
      sitecoreData,
      allowedTerminals,
      updateSitecoreData,
      updateAllowedTerminals,
      updateUserEmail,
      userEmail
    };
  },
  {
    persist: false
  }
);
